
import index from './components/index.vue'
import news from './components/news.vue'
import newsdetail from './components/newsdetail.vue'
import product from './components/product.vue'
import prodetail from './components/prodetail.vue'
import zhwl from './components/zhwl.vue'
import zhwldet from './components/zhwldet.vue'
import shzr from './components/shzr.vue'
import shzrdetail from './components/shzrdetail.vue'
import yxfw from './components/yxfw.vue'
import joinus from './components/joinus.vue'
import about from './components/about.vue'
import aboutdet from './components/aboutdet.vue'
import hxys from './components/hxys.vue'

export default {
	mode:'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path:'/',
			component:index,
			name:'首页',
			meta:{
				// 页面标题title
				title: '江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/about',
			component:about, 
			name:'走进双沟 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '走进双沟 - 江苏双沟酒业股份有限公司'
			},
		},

		{
			path:'/news', 
			component:news, 
			name:'动态资讯 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '动态资讯 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/newsdetail', 
			component:newsdetail, 
			name:'资讯详情 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '资讯详情 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/product', 
			component:product, 
			name:'品牌产品 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '品牌产品 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/prodetail', 
			component:prodetail, 
			name:'产品详情 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '产品详情 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/zhwl', 
			component:zhwl, 
			name:'智慧文旅 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '智慧文旅 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/zhwldet', 
			component:zhwldet, 
			name:'文旅图片 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '文旅图片 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/shzr', 
			component:shzr, 
			name:'社会责任 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '社会责任 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/shzrdetail', 
			component:shzrdetail, 
			name:'社会责任 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '社会责任 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/yxfw', 
			component:yxfw, 
			name:'服务支持 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '服务支持 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/joinus', 
			component:joinus, 
			name:'加入我们 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '加入我们 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/about', 
			component:about, 
			name:'走进双沟 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '走进双沟 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/aboutdet', 
			component:aboutdet, 
			name:'企业荣誉 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '企业荣誉 - 江苏双沟酒业股份有限公司'
			},
		},
		{
			path:'/hxys', 
			component:hxys, 
			name:'核心优势 - 江苏双沟酒业股份有限公司',
			meta:{
				// 页面标题title
				title: '核心优势 - 江苏双沟酒业股份有限公司'
			},
		},
		
	]
}